import FJDisplayHeaderContainer from '../../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer.jsx';
import FJCreationPanelContainer from '../../../FJMainPreview/FJCreationPanel/FJCreationPanelContainer.jsx';
import FJHistoryPanelContainer from '../../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer.jsx';
import FJAIVideoGeneratorProgress from './FJAIVideoGeneratorProgress.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJDropdownNew from '../../../../common/components/FJDropDown/FJDropdownNew.jsx';
import FJSortIcon from '../../../../assets/svg/sort.svg?react';
import FJCheckIcon from '../../../../assets/svg/check.svg?react';
import FJArrowIcon from '../../../../assets/svg/button-pull-down.svg?react';
import { useRef } from 'react';
import FJDragBox from '../../../../common/components/FJDragBox/FJDragBox.jsx';
import PropTypes from 'prop-types';
import FJCreationPreview from '../../../../common/combineComponents/FJCreationPreview/FJCreationPreview.jsx';
import { AI_GENERATOR_VIDEO_TAB_TYPE } from '../../../../config/dataConfig/FJAIVideoGeneratorData.js';
import FJAIVideoModelPicker from './FJAIVideoModelPicker.jsx';

import styles from './FJAIVideoGeneratorRight.module.less';
import FJConstant from '../../../../constants/FJConstant.js';
import FJCommunityHomeContainer from '../../../FJCommunity/FJCommunityRight/FJCommunityHome/FJCommunityHomeContainer.jsx';

const FJAIVideoGeneratorRight = props => {
    const {
        currentGenerateStatus,
        imgUrl,
        getCredit,
        headerTabIndex,
        generatingVideoNum = 0,
        isShowGeneratingVideoNum,
        sortType,
        setSortType,
        showHistoryNum,
        setIsDraggingFile,
        uploadFile,
        reGenerate,
        jumpHistory,
        creditNumber,
        videoEffectPresetList,
        tabIndex,
        onUse,
        generationType,
        // 模型选择器相关props
        isModelPickerVisible,
        currentModel,
        onModelChange,
        onModelPickerToggle,
        model,
    } = props;

    const isShowPresetImageBox = currentGenerateStatus === FJConstant.IDLE;

    const filterList = useRef(['all-videos', 'image-to-video', 'text-to-video', 'ai-video-effect']);
    const dropRef = useRef(null);

    const _renderBtnGroup = () => {
        if (generatingVideoNum > 0 && isShowGeneratingVideoNum) {
            return (
                <div className={styles.num}>
                    {generatingVideoNum === 1
                        ? FJLocalStore._('generating-video').replace('xxx', generatingVideoNum)
                        : FJLocalStore._('generating-videos').replace('xxx', generatingVideoNum)}
                </div>
            );
        }
        return null;
    };
    const _renderTrigger = config => {
        return (
            <div className={styles.sort_btn} ref={config.ref} onClick={config.onClick}>
                <div className={styles.sort_content}>
                    <FJSortIcon className={styles.left_icon} />
                    {FJLocalStore._(sortType)}
                </div>
                <FJArrowIcon className={styles.right_icon} />
            </div>
        );
    };

    const _renderOverlay = config => {
        return (
            <div className={styles.overlay_box} ref={config.ref}>
                <ul>
                    {filterList.current.map(item => (
                        <li
                            className={sortType === item ? styles.active : ''}
                            onClick={() => {
                                dropRef.current.hide();
                                setSortType(item);
                            }}
                            key={item}
                        >
                            {FJLocalStore._(item)}
                            <FJCheckIcon />
                        </li>
                    ))}
                </ul>
            </div>
        );
    };

    const renderHeader = () => {
        return (
            <div className={styles.history_header}>
                <div className={styles.history_num}>
                    {FJLocalStore._(showHistoryNum === 1 ? '_result' : '_results').replace('xxx', showHistoryNum)}
                </div>
                <FJDropdownNew
                    renderTrigger={_renderTrigger}
                    renderOverlay={_renderOverlay}
                    placement='bottomRight'
                    offsetTop={4}
                    useAnchorBody
                    ref={dropRef}
                    isTopLayer
                />
            </div>
        );
    };
    return (
        <div style={{ position: 'relative', flex: '1', overflow: 'hidden', height: '100%' }}>
            <FJDragBox setIsDragging={setIsDraggingFile} uploadFile={uploadFile} className={styles.app_right}>
                <FJDisplayHeaderContainer rightChildren={_renderBtnGroup()} className={styles.header} />
                <FJCommunityHomeContainer active={headerTabIndex === FJConstant.COMMUNITY} embedded={true} />
                {(currentGenerateStatus === FJConstant.IDLE || currentGenerateStatus === FJConstant.SUCCESS) && (
                    <>
                        <FJCreationPanelContainer
                            activeHeaderTabIndex={
                                tabIndex !== AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO ||
                                currentGenerateStatus === FJConstant.SUCCESS
                                    ? FJConstant.CREATIONS
                                    : null
                            }
                            hideCompare={true}
                            isShowPresetImageBox={isShowPresetImageBox}
                        />
                        <FJCreationPreview
                            active={
                                tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO &&
                                currentGenerateStatus === FJConstant.IDLE &&
                                headerTabIndex === FJConstant.CREATIONS
                            }
                            list={videoEffectPresetList}
                            use={onUse}
                        />
                    </>
                )}
                {(currentGenerateStatus === FJConstant.RUNNING ||
                    currentGenerateStatus === FJConstant.ERROR ||
                    currentGenerateStatus === FJConstant.VIOLATION ||
                    currentGenerateStatus === FJConstant.IMAGE_WITHOUT_PERSON ||
                    currentGenerateStatus === FJConstant.VIDEO_WITHOUT_PERSON ||
                    currentGenerateStatus === FJConstant.WAITING) &&
                    headerTabIndex === FJConstant.CREATIONS && (
                        <FJAIVideoGeneratorProgress
                            imgUrl={imgUrl}
                            getCredit={getCredit}
                            status={currentGenerateStatus}
                            reGenerate={reGenerate}
                            jumpHistory={jumpHistory}
                            creditNumber={creditNumber}
                            isVideoEffect={generationType === 'ev'}
                            model={model}
                        />
                    )}
                <FJHistoryPanelContainer activeHeaderTabIndex={FJConstant.HISTORY} headerChildren={renderHeader()} />
            </FJDragBox>
            {/* 特殊处理：避免tab切换/模型显隐时，频繁加载资源而卡顿 */}
            {/* <FJAIVideoModelPicker
                currentModel={currentModel}
                onChange={onModelChange}
                isVisible={isModelPickerVisible && tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO}
                onToggle={onModelPickerToggle}
                tab={AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO}
            />
            <FJAIVideoModelPicker
                currentModel={currentModel}
                onChange={onModelChange}
                isVisible={isModelPickerVisible && tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO}
                onToggle={onModelPickerToggle}
                tab={AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO}
            /> */}
        </div>
    );
};

FJAIVideoGeneratorRight.propTypes = {
    currentGenerateStatus: PropTypes.string,
    imgUrl: PropTypes.string,
    getCredit: PropTypes.func,
    headerTabIndex: PropTypes.string,
    generatingVideoNum: PropTypes.number,
    isShowGeneratingVideoNum: PropTypes.bool,
    sortType: PropTypes.string,
    setSortType: PropTypes.func,
    showHistoryNum: PropTypes.number,
    setIsDraggingFile: PropTypes.func,
    uploadFile: PropTypes.func,
    reGenerate: PropTypes.func,
    jumpHistory: PropTypes.func,
    creditNumber: PropTypes.number,
    videoEffectPresetList: PropTypes.array,
    tabIndex: PropTypes.string,
    onUse: PropTypes.func,
    generationType: PropTypes.string,
    onModelChange: PropTypes.func,
    onModelPickerToggle: PropTypes.func,
    isModelPickerVisible: PropTypes.bool,
    currentModel: PropTypes.string,
    model: PropTypes.string,
};

export default FJAIVideoGeneratorRight;
